import { jsx as _jsx } from "react/jsx-runtime";
import { RoleType } from 'common/types/server-api-dtos';
import { useBalanceAndNotificationData } from 'common/services/balance-and-notification-service/query';
import { useComplianceData } from 'common/services/compliance-service/query';
import { useProfileData } from 'common/services/profile-service/query';
import { useCustomizationData } from 'common/services/customizations-service/query';
import { useShowBalanceData } from 'common/services/show-balance-service/query';
import { useSupportRequestTypesData } from 'common/services/support-request-types-service/query';
import { useConversionData } from 'common/services/conversion-service/query';
import { useBenefitConversionData } from 'common/services/benefit-conversion-service/query';
import { useBenefitCompanyBalanceData } from 'common/services/benefit-company-balance-service/query';
import { useCompanyAdditionalInfoData } from 'common/services/company-additional-info-service/query';
import { useSupervisorData } from 'common/services/supervisor-service/query';
import { useChatUnreadData } from 'common/services/chat-unread-service/query';
import { userService } from 'common/utils/user-service';
import { useChatSignalR } from 'pages/user-pages/chat-page/service/chat-signal-r-service';
export var BaseServiceObserver = function () {
    var isCompanyCreator = userService.hasRole(RoleType.CompanyCreator);
    if (isCompanyCreator) {
        return null;
    }
    return _jsx(BaseServiceObserverRoot, {});
};
var BaseServiceObserverRoot = function () {
    useProfileData();
    useSupervisorData();
    useCustomizationData();
    useComplianceData();
    useChatSignalR();
    useBalanceAndNotificationData();
    useChatUnreadData();
    useShowBalanceData();
    useSupportRequestTypesData();
    useConversionData();
    useBenefitConversionData();
    useBenefitCompanyBalanceData();
    useCompanyAdditionalInfoData();
    return null;
};
